<template>
  <div class="nt-search-primary">
    <div class="nt-search-primary__form">
      <div class="input">
        <svg class="iconx">
          <use xlink:href="#icon-search"></use>
        </svg>
        <slot name="input" :curr="curr" :oninput="onInput" :clear="clearResult" :show="show"></slot>
        <div>
          <div @click="goSearch(curr)">
            <slot name="button"></slot>
          </div>
        </div>
      </div>
      <div v-if="!urlRedirect" class="actions">
        <span>View Mode: </span>
        <div :class="['icon-act', typeView === 1 ? 'icon-act--active' : '']" @click="typeViewClick(1)">
          <svg>
            <use xlink:href="#icon-view-card" />
          </svg>
        </div>
        <div :class="['icon-act', typeView === 2 ? 'icon-act--active' : '']" @click="typeViewClick(2)">
          <svg>
            <use xlink:href="#icon-view-list" />
          </svg>
        </div>
      </div>
    </div>
    <div v-show="showResult" class="nt-search-primary__results">
      <div class="nt-search-primary__item" v-for="(item, index) in result" :key="item.id">
        <slot v-bind="item" :click="goSearch" :curr="curr" :index="index"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { reduce } from 'lodash'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'nt-search-primary',
  props: {
    urlMenu: {
      type: String,
      required: true
    },
    urlRedirect: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      text: '',
      curr: '',
      result: [],
      showResult: false,
      timer: null,
      directional: !!this.$props.urlRedirect
    }
  },
  created() {
    const { search } = window.location

    if (!search) return

    const params = this.getQuery(search)

    if (params.ntSearch) {
      this.curr = params.ntSearch
    }
    this.changeText(this.curr)
    this.getMenuData(this.curr)
  },
  computed: {
    ...mapGetters(['typeView'])
  },
  methods: {
    ...mapActions([
      'changeTypeView',
      'changeMenuList',
      'changeText'
    ]),
    getQuery(search) {
      const items = decodeURI(search).replace('?', '').split('&')

      return reduce(items, (memo, item) => {
        const values = item.split('=')

        return Object.assign(memo, {
          [values[0]]: values[1]
        })
      }, {})
    },
    onInput(event) {
      const { value } = event.target
      // Reset timer on change text
      clearTimeout(this.timer)
      // Aux variable
      this.curr = value
      // Restart timer
      this.exectimer(value)

      this.show()
    },
    exectimer(value) {
      this.timer = setTimeout(() => {
        if (value !== this.text) {
          this.text = value
          this.changeFilter(value)
        }
      }, 500)
    },
    changeFilter(value) {
      // Value undefined
      if (!value) {
        this.clearResult()
        return
      }
      // Min size necessary (3)
      if (value.length < 3) {
        this.result = []
        return
      }
      // Request data
      this.getMenuData(value)
    },
    getMenuData(param) {
      axios.get(this.urlMenu, {
        params: {
          QuerySearch: param
        }
      }).then((response) => {
        this.result = response.data
        this.changeMenuList(this.result)
      })
    },
    clearResult() {
      this.showResult = false
    },
    show() {
      this.showResult = true
    },
    goSearch(value) {
      event.preventDefault()

      this.curr = value

      this.changeText(this.curr)

      this.redirect()
    },
    redirect() {
      if (!this.directional) {
        this.clearResult()
        let url = window.location.pathname

        if (this.curr) {
          url = `${url}?ntSearch=${this.curr}`
        }
        window.history.pushState(this.curr, '', url)

        this.$root.$emit('changedSearch', {
          value: this.curr
        })

        return
      }

      let url = this.urlRedirect

      if (this.curr) {
        url = `${url}?ntSearch=${this.curr}`
      }
      window.location.href = url
    },
    typeViewClick(value) {
      this.changeTypeView(value)
    }
  }
}
</script>
